module.exports = __webpack_public_path__ + "static/media/ic_fan_open.cd0dfc91.png";